export function formatStationName(name: string) {
  return name.replace(/\s+/g, '-');
}